import React from 'react';
import 'aos/dist/aos.css'
// import social data
import { social } from '../data';

// import logo
import Logo from '../assets/img/Logo.png';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const Footer = () => {
  const { Theme } = useContext(ThemeContext)
  return (
    <footer className={`${Theme === "dark" ? "f-n-dark  border-[#F2AA4CFF]" : "lightBackgound border-red-400"} bg-transition border-t-4 py-10`} >
      <div className='container mx-auto' >
        <div className='flex flex-col lg:flex-row space-y-6 lg:space-y-0 items-center justify-between'>
          <div>
            <a href="#" target='_blank'>
              <img src={Logo} alt="Logo" style={{ "width": "60px" }} />
            </a>
          </div>
          <p className={`${Theme === "dark" ? "text-white" : "text-black"} opacity-80 text-[15px]`}>
            © 2023 Designed and Built by Monu Yadav
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

